export default "__VITE_ASSET__DwsHr3wm__"